import { j as t } from "./atoms-v218.js";
import { useMemo as y } from "react";
import { TableDataCellContent as M, DayText as F, StrikePriceText as H, PriceText as A, DashText as E } from "./atoms-v21334.js";
import { filledBlockSkeletonHOC as I } from "./atoms-v21335.js";
function w({
  colorTheme: $ = "light",
  dateConfig: u,
  hasEndDateSelected: C,
  hasEndOfActiveRangeCell: f,
  hasMinSelection: D,
  hasPriceContent: m,
  isBridgeDateInclusive: i,
  isCheckoutDate: l,
  isConsideredBridgeDate: n,
  isDisabledForAvailability: s,
  isDisabledForNextMonth: S,
  isDisabledForOverflow: x,
  isDisabledForPreviousMonth: a,
  isDisabledForRange: r,
  isDisabledInclusive: o,
  isEndDate: e,
  isEndOfActiveRangeCell: T,
  isFirstOfType: p,
  isHighlightedOverflowCell: v,
  isHovered: d,
  isLastOfType: O,
  isMinSelectionOverflowCell: b,
  isRightSideBoundaryOfConsideredBridgeDates: j,
  isRightSideBoundaryOfMinSelectionRange: B,
  isSelectedBridgeDate: c,
  isStartDate: h,
  priceText: R,
  strikePriceText: g
}) {
  const k = y(() => !x, [x]);
  return /* @__PURE__ */ t.jsx(
    M,
    {
      $colorTheme: $,
      $dateConfig: u,
      $hasEndDateSelected: C,
      $hasEndOfActiveRangeCell: f,
      $hasMinSelection: D,
      $hasPriceContent: m,
      $hasStrikeThroughText: !!g,
      $isBridgeDateInclusive: i,
      $isCheckoutDate: l,
      $isConsideredBridgeDate: n,
      $isDisabledForAvailability: s,
      $isDisabledForNextMonth: S,
      $isDisabledForOverflow: x,
      $isDisabledForPreviousMonth: a,
      $isDisabledForRange: r,
      $isDisabledInclusive: o,
      $isEndDate: e,
      $isEndOfActiveRangeCell: T,
      $isFirstOfType: p,
      $isHighlightedOverflowCell: v,
      $isHovered: d,
      $isLastOfType: O,
      $isMinSelectionOverflowCell: b,
      $isRightSideBoundaryOfConsideredBridgeDates: j,
      $isRightSideBoundaryOfMinSelectionRange: B,
      $isSelectedBridgeDate: c,
      $isStartDate: h,
      "data-testid": "cell-content-element",
      children: k && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
        /* @__PURE__ */ t.jsx(
          F,
          {
            $colorTheme: $,
            $isBridgeDateInclusive: i,
            $isCheckoutDate: l,
            $isConsideredBridgeDate: n,
            $isDisabledForAvailability: s,
            $isDisabledForPreviousMonth: a,
            $isDisabledForRange: r,
            $isDisabledInclusive: o,
            $isEndDate: e,
            $isHovered: d,
            $isSelectedBridgeDate: c,
            $isStartDate: h,
            "data-testid": "cell-content-date-element",
            children: u.value
          }
        ),
        m && g && !e && /* @__PURE__ */ t.jsx(
          H,
          {
            $isPriceText: !0,
            $colorTheme: $,
            $isBridgeDateInclusive: i,
            $isCheckoutDate: l,
            $isConsideredBridgeDate: n,
            $isDisabledForAvailability: s,
            $isDisabledForPreviousMonth: a,
            $isDisabledForRange: r,
            $isDisabledInclusive: o,
            $isEndDate: e,
            $isHovered: d,
            $isSelectedBridgeDate: c,
            $isStartDate: h,
            "data-testid": "cell-content-strike-price-text-element",
            children: g
          }
        ),
        m && !e && /* @__PURE__ */ t.jsx(
          A,
          {
            $isPriceText: !0,
            $colorTheme: $,
            $isBridgeDateInclusive: i,
            $isCheckoutDate: l,
            $isConsideredBridgeDate: n,
            $isDisabledForAvailability: s,
            $isDisabledForPreviousMonth: a,
            $isDisabledForRange: r,
            $isDisabledInclusive: o,
            $isEndDate: e,
            $isHovered: d,
            $isSelectedBridgeDate: c,
            $isStartDate: h,
            "data-testid": "cell-content-price-text-element",
            children: R
          }
        ),
        m && e && /* @__PURE__ */ t.jsx(
          E,
          {
            $colorTheme: $,
            $isBridgeDateInclusive: i,
            $isCheckoutDate: l,
            $isConsideredBridgeDate: n,
            $isDisabledForAvailability: s,
            $isDisabledForPreviousMonth: a,
            $isDisabledForRange: r,
            $isDisabledInclusive: o,
            $isEndDate: e,
            $isHovered: d,
            $isSelectedBridgeDate: c,
            $isStartDate: h,
            "data-testid": "cell-content-checkout-date-element",
            children: "--"
          }
        )
      ] })
    }
  );
}
const z = I(w);
export {
  z as CalendarTableDataCellContent
};
